
import { Component, Prop, Vue } from 'vue-property-decorator';
import { WebsiteComposite } from '@/services/Website/interfaces';

@Component
export default class AliasCreatePanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  public domainInput = '';

  public enableEmail = true;

  private readonly DOMAIN_REGEX = /^(?=.{1,253}$)([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/;

  public get domain(): string {
    return this.composite.website.domain;
  }

  public get domainRules(): Array<(value: string) => boolean | string> {
    return [
      (value: string) => !!value.trim() || 'Domain is required',
      (value: string) => this.DOMAIN_REGEX.test(value.trim()) || 'Invalid domain',
    ];
  }

  public get valid(): boolean {
    return this.DOMAIN_REGEX.test(this.domainInput.trim());
  }

  public onSubmit(): void {
    if (!this.valid) {
      return;
    }

    const excludeActions: string[] = this.enableEmail ? [] : ['email'];

    this.$emit('submit', { domain: this.domainInput.trim(), excludeActions });
  }
}
